<p-confirmDialog></p-confirmDialog>

<div class="flex flex-col gap-4 frame pb-5 my-2">
  <div class="flex gap-4 items-center bg-surface-50 dark:bg-surface-800 rounded-t-lg p-5" *ngIf="!!!(disabled | async)">
    <p-button type="button" [label]="'milestone.form.add_slot' | translate" (onClick)="addLot()" [disabled]="disabled | async">
      <i class="pi pi-plus"></i>
    </p-button>
    <p-button
      type="button"
      [label]="'common.text_groups.remove_all' | translate"
      (onClick)="clearAllLots()"
      severity="secondary"
      [disabled]="(disabled | async) || slots.length === 0">
      <i class="pi pi-trash"></i>
    </p-button>
  </div>

  <div class="flex flex-col gap-0.5">
    <div *ngFor="let item of slots; let i = index; trackBy: trackByFn">
      <div class="flex flex-row gap-5 p-5 justify-center items-center">
        <div class="flex flex-col gap-2 w-full items-center justify-center">
          <div class="flex flex-col 2xl:flex-row gap-4 w-full">
            <!-- Description -->
            <div class="flex flex-col gap-2 w-full 2xl:w-3/4">
              <label [for]="'text-' + uid + i" class="text-xs font-bold">{{ 'milestone.form.slot_label' | translate }}</label>
              <input
                [id]="'text-' + uid + i"
                pInputText
                fluid
                [ngModel]="item.description"
                [disabled]="!!(disabled | async)"
                (ngModelChange)="updateText(i, $event)"
                [class.ng-invalid]="(errors | async)?.[i]?.description"
                [class.ng-dirty]="(errors | async)?.[i]?.description" />
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.description || ''">
                {{ (errors | async)?.[i]?.description }}
              </p>
            </div>

            <!-- Budget -->
            <div class="flex flex-col gap-2 w-full 2xl:w-1/4">
              <label [for]="'number-' + uid + i" class="text-xs font-bold">{{ 'milestone.form.slot_budget' | translate }}</label>
              <p-inputnumber
                [id]="'number-' + uid + i"
                mode="decimal"
                fluid
                minFractionDigits="0"
                maxFractionDigits="2"
                [ngModel]="item.budget"
                [disabled]="!!(disabled | async)"
                [class.ng-invalid]="(errors | async)?.[i]?.budget"
                [class.ng-dirty]="(errors | async)?.[i]?.budget"
                (ngModelChange)="updateNumber(i, $event)" />
              <p class="text-xs text-red-500 font-bold" *ngIf="(errors | async)?.[i]?.budget || ''">
                {{ (errors | async)?.[i]?.budget }}
              </p>
            </div>
          </div>
        </div>

        <div class="mt-5" *ngIf="!!!(disabled | async)">
          <button type="button" (click)="removeLot(i)" [disabled]="!!(disabled | async)">
            <i [ngClass]="['pi pi-eraser', (disabled | async) ? 'text-gray-200' : 'hover:text-red-500']"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
